// import './pop-up.scss'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { toastr } from 'react-redux-toastr'
import {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input'
import { IonInput, IonItem, IonList, IonSpinner } from '@ionic/react'
import { connectLoginPopUp } from '../loginPopUp.connect'
import SignUpStep1 from '../SignUpTab/images/step1.svg'
import SignUpStep2 from '../SignUpTab/images/step2.svg'
import allSet from './images/allSet.png'
import rulesAccepted from './images/rulesAccepted.svg'
import eye from '../../../assets/images/eye.svg'
import eyeOff from '../../../assets/images/eyeOff.svg'
import closeLogin from '../../../assets/images/closeLogin.svg'
import { useSelector } from 'react-redux'
import { countryCodesArray } from '../../Verification/countryCodes'
import Select from 'react-select'
import { countryOptions } from '../../../helpers/countryList'

const ForgotPasswordTab = ({
  actions,
  recaptchaResponse,
  onDidDismiss,
  width,
}) => {
  const [mobile, setMobile] = useState(false)
  const [countryCode, setCountryCode] = useState(false)

  const [isValid, setIsValid] = useState(false)
  const [message, setMessage] = useState('')
  const [step, setStep] = useState(5)
  const [isSending, setIsSending] = useState(false)
  const [isSendingOtp, setIsSendingOtp] = useState(true)
  const [orderId, setOrderId] = useState('')
  const [memberCode, setMemberCode] = useState()

  const [hideFirstPass, setHideFirstPass] = useState(false)
  const [hideSecondPass, setHideSecondPass] = useState(false)

  const [mobileNumCounter, setMobileNumCounter] = useState(0)
  const refRecaptcha = useRef(null)

  const logo = useSelector((state) => state.logo)

  const getBalance = (memberCode) => {
    actions
      .requestBalance(memberCode)
      .then((res) => {
        if (res.data.result.availBalance < 100) {
          // history.push("/deposit")
        }
      })
      .catch((e) => console.log('balance error = ', e))
  }

  // const login = async () => {
  //   try {
  //     if (!mobile || !password) return
  //     setIsSending(true)
  //     const recaptchaResponseExecute =
  //       await recaptchaResponse.current.executeAsync()

  //     let newUserName = ''
  //     newUserName = `91_${mobile}`
  //     await actions
  //       .requestAuth({
  //         username: newUserName,
  //         password,
  //         recaptchaResponse: recaptchaResponseExecute,
  //         answer: '',
  //         token: '',
  //       })
  //       .then((res) => {
  //         console.log('res', res)
  //         getBalance(res.data.result.memberCode)
  //         onDidDismiss()
  //         setIsSending(false)
  //       })
  //   } catch (e) {
  //     setIsSending(false)
  //     toastr.error('', `${e}`)
  //     if (refRecaptcha.current) refRecaptcha.current.reset()
  //   }
  // }

  const mobileValidation = async (e) => {
    setIsSending(true)
    console.log(isSending)
    if (mobile.length !== 10) {
      setMessage('This field is required!')
      setIsSending(false)
      return
    } else if (isValid) {
      // actions.requestRecaptcha()

      setMessage('')
      const recaptchaResponseExecute =
        await recaptchaResponse.current.executeAsync()
      console.log('recaptchaResponse', recaptchaResponseExecute)
      const data = {
        countryCode: `+${countryCode}`,
        mobileNumber: `${mobile}`,
        recaptchaResponse: `${recaptchaResponseExecute}`,
      }

      await actions
        .postNumberForgotPassword(data)
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            setStep(2)
            setIsSending(false)
          }
        })
        .catch((e) => toastr.error('', `${e}`))

      console.log('SENDING MOB')
    }
  }

  const initialMinute = 0,
    initialSeconds = 59
  const [minutes, setMinutes] = useState(initialMinute)
  const [seconds, setSeconds] = useState(initialSeconds)

  useEffect(() => {
    if (step === 2) {
      let myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1)
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval)
          } else {
            setMinutes(minutes - 1)
            setSeconds(59)
          }
        }
      }, 1000)
      return () => {
        clearInterval(myInterval)
      }
    }
  })

  const validateMobile = (e) => {
    const value = e?.target?.value
    setMobileNumCounter(value.length)
    if (value?.length <= 10) {
      e.target.value = value?.replace(/[^\d]/g, '')
      setUsername(e.target.value)
    } else {
      e.target.value = username
    }
    setMobileNumCounter(value.length)
    setIsSending(false)
    if (value?.length === 10) {
      setIsSendingNew(false)
      setIsSending(false)
      setSeconds(59)
      setSecondsNew(59)
    }
    if (!value) {
      setMessage('This field is required!')
      return
    } else if (value.length !== 10) {
      setMessage('Phone number must be 10 digits')
      setIsValid(false)
    } else if (isPossiblePhoneNumber(`+91${value}`)) {
      setIsValid(true)
      setMobile(value)
      const phoneNumber = parsePhoneNumber(`+91${value}`)
      if (phoneNumber) {
        const code = phoneNumber.countryCallingCode
        setCountryCode(code)
        setMessage('')
      }

      setMessage('')
    }
    console.log(isPossiblePhoneNumber(`+91${value}`))
  }

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      // submit()
    }
  }

  const [otpMessage, setOtpMessage] = useState('')
  const [isOtpValid, setIsOtpValid] = useState(false)
  const [password, setPassword] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState(false)
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const [isConfirmValid, setConfirmIsValid] = useState(false)

  const [passwordMessage, setPasswordMessage] = useState('')
  const [confirmMessage, setConfirmMessage] = useState('')

  const [isRulesAccepted, setIsRulesAccepted] = useState('')

  const ref_input = useRef()
  const [otp, setOtp] = useState()

  const isDisabledButton = () => {
    if (
      isSending ||
      otpMessage ||
      confirmMessage ||
      passwordMessage ||
      !isPasswordValid ||
      !isConfirmValid ||
      !isPasswordValid
    ) {
      return true
    } else {
      return false
    }
  }

  const validatePassword = (password) => {
    // event.preventDefault();
    setIsSending(false)
    const regex = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g
    const regexTesting = regex.test(password)

    if (password.length < 8 || password.length > 40) {
      setIsPasswordValid(false)
      setPasswordMessage('The password must be between 8 and 40 characters')
    } else if (!regexTesting) {
      console.log('regex tested')
      setIsPasswordValid(false)
      setPasswordMessage(
        'Must be atleast 8 characters, 1 number, 1 letter in capital and small case, 1 special characters: $@#%&8-=?+'
      )
    } else {
      setIsPasswordValid(true)
      setPasswordMessage('')
      setConfirmIsValid(true)
      setConfirmMessage(true)
      setPassword(password)
    }
  }

  const validatePasswordConfirm = (confirmPassword) => {
    setIsSending(false)
    // event.preventDefault();

    // const confirmPassword = event.target.value;

    if (confirmPassword.length < 8 || confirmPassword.length > 40) {
      setConfirmIsValid(false)
      setConfirmMessage('The password must be between 8 and 40 characters')
    } else {
      setConfirmIsValid(true)
      setConfirmMessage('')
      setPasswordMessage('')
      setIsPasswordValid(true)
      setConfirmPassword(confirmPassword)
    }
  }

  const [otpUser, setOtpUser] = useState('')

  const validateOtp = (otp) => {
    setOtpUser(otp)
    if (otp.length !== 6) {
      setIsOtpValid(false)
    } else {
      // ref_input.current.focus()
      setIsOtpValid(true)
      setOtpMessage('')
      setOtp(otp)
    }
    console.log('otpMessage', otpMessage)
  }

  const resendOTP = async () => {
    const dataOTP = {
      orderId: orderId,
    }

    await actions
      .resetOtp(dataOTP)
      .then((res) => {
        if (res.status) {
          toastr.success('', `${res.data.msg}`)
          setTimeLeft(Number(res.data.otp_expiry_time))
        } else {
          toastr.error('', `${res.data.msg}`)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }

  // const next = async (e) => {
  //   setIsSending(true)
  //   if (!otp) {
  //     setOtpMessage('This field is required!')
  //     setIsValid(false)
  //     console.log('OTP Empty')
  //     setIsSending(false)
  //   } else if (otp.length !== 4) {
  //     setIsValid(false)
  //     setOtpMessage('OTP you entered is invalid')
  //     console.log('OTP invalid')
  //     setIsSending(false)
  //   } else if (!password || !confirmPassword) {
  //     setIsValid(false)
  //     setPasswordMessage('This field is required!')
  //     setConfirmIsValid(false)
  //     setConfirmMessage('This field is required!')
  //     console.log('pass do not match')
  //     setIsSending(false)
  //   } else if (password !== confirmPassword) {
  //     setIsValid(false)
  //     setPasswordMessage('Passwords do not match')
  //     setConfirmIsValid(false)
  //     setConfirmMessage('Passwords do not match')
  //     console.log('pass do not match')
  //     setIsSending(false)
  //   } else if (
  //     isOtpValid &&
  //     isValid &&
  //     isConfirmValid &&
  //     otp.length === 4 &&
  //     password === confirmPassword
  //   ) {
  //     setIsOtpValid(true)
  //     setMessage('')
  //     setConfirmMessage('')
  //     setConfirmIsValid(true)
  //     setIsValid(true)
  //     console.log('VALIDATION PASSED')
  //     const data = {
  //       countryCode: `+${countryCode}`,
  //       mobileNumber: `${mobile}`,
  //       OTP: `${otp}`,
  //       password: `${password}`,
  //       confirmPassword: `${confirmPassword}`,
  //     }
  //     await actions
  //       .verifyForgotPasswordOTP(data)
  //       .then((res) => {
  //         console.log(res)
  //         if (res.status === 200) {
  //           setMemberCode(res?.data?.result?.memberCode)
  //           console.log(res?.data?.result?.memberCode)
  //           console.log(memberCode)
  //           setStep(3)
  //           setIsSending(false)
  //           // console.log('SUCCESS')
  //         }
  //       })
  //       .catch((e) => toastr.error('', `${e}`))

  //     // setPreVal(true)
  //   }
  // }

  const [focus, setFocus] = useState(false)

  const onfocusInput = () => {
    setFocus(true)
  }
  const onBlurInput = () => {
    setFocus(false)
  }

  const [otpSent, setOtpSent] = useState(false)
  const [isSendingNew, setIsSendingNew] = useState(false)

  const mobileValidationNew = async (e) => {
    setIsSendingNew(true)
    console.log(isSending)
    if (mobile.length !== 10) {
      setMessage('This field is required!')
      setIsSendingNew(false)
      return
    } else if (isValid) {
      // actions.requestRecaptcha()

      setMessage('')
      const recaptchaResponseExecute =
        await recaptchaResponse.current.executeAsync()
      console.log('recaptchaResponse', recaptchaResponseExecute)
      const data = {
        countryCode: `+${countryCode}`,
        mobileNumber: `${mobile}`,
        recaptchaResponse: `${recaptchaResponseExecute}`,
      }

      await actions
        .postNumberForgotPassword(data)
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            toastr.success('', `${res?.data?.result}`)
            setOtpSent(true)
          }
        })
        .catch((e) => {
          setIsSendingNew(false)
          toastr.error('', `${e}`)
        })

      console.log('SENDING MOB')
    }
  }

  // const mobileValidationNew = async (e) => {

  //   setIsSendingNew(true)

  //   if (mobile.length !== 10) {
  //     setMessage('This field is required!')
  //     setIsSendingNew(false)
  //     return
  //   } else if (isValid) {
  //     // actions.requestRecaptcha()

  //     setMessage('')
  //     const recaptchaResponseExecute =
  //       await recaptchaResponse.current.executeAsync()
  //     console.log('recaptchaResponse', recaptchaResponseExecute)
  //     const data = {
  //       countryCode: `+${countryCode}`,
  //       mobileNumber: `${mobile}`,
  //       recaptchaResponse: `${recaptchaResponseExecute}`,
  //     }

  //     await actions
  //       .postNumberSignUp(data)
  //       .then((res) => {
  //         console.log(res)
  //         if (res.status === 200) {
  //           // console.log('res', res)
  //           toastr.success('', `${res?.data?.result}`)
  //           setOtpSent(true)
  //         }
  //       })
  //       .catch((e) => {
  //         setIsSendingNew(false)
  //         toastr.error('', `${e}`)
  //       })

  //     console.log('SENDING MOB')
  //   }
  // }

  const initialMinuteNew = 0,
    initialSecondsNew = 59
  const [minutesNew, setMinutesNew] = useState(initialMinuteNew)
  const [secondsNew, setSecondsNew] = useState(initialSecondsNew)
  let [username, setUsername] = useState('')

  useEffect(() => {
    if (otpSent) {
      let myIntervalNew = setInterval(() => {
        console.log('minusSet')
        if (secondsNew > 0) {
          setSecondsNew(secondsNew - 1)
          console.log('minus1')
        }
        if (secondsNew === 0) {
          if (minutesNew === 0) {
            clearInterval(myIntervalNew)
          } else {
            setMinutesNew(minutesNew - 1)
            setSecondsNew(59)
          }
        }
      }, 1000)
      return () => {
        clearInterval(myIntervalNew)
      }
    }
  })

  useEffect(() => {
    if (confirmPassword !== password) {
      setConfirmIsValid(false)
      setConfirmMessage('Passwords do not match')
    }
  }, [confirmPassword, password])

  const [ipData, setIpData] = useState(null)

  const fetchIp = async () => {
    try {
      const response = await fetch(
        'https://api.ipgeolocation.io/ipgeo?apiKey=84a7943dbd744b0da4dce58e1c75702e'
      )
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      const result = await response.json()
      setIpData(result)
    } catch (error) {
      console.error('Failed to fetch IP data:', error)
    }
  }

  useEffect(() => {
    fetchIp()
  }, [])

  const nextNew = async (e) => {
    setIsSending(true)

    if (!password || !confirmPassword) {
      setIsValid(false)
      setPasswordMessage('This field is required!')
      setConfirmIsValid(false)
      setConfirmMessage('This field is required!')
      console.log('pass do not match')
      setIsSending(false)
    } else if (password !== confirmPassword) {
      setIsValid(false)
      setPasswordMessage('Passwords do not match')
      setConfirmIsValid(false)
      setConfirmMessage('Passwords do not match')
      console.log('pass do not match')
      setIsSending(false)
    } else if (password === confirmPassword) {
      setIsOtpValid(true)
      setMessage('')
      setConfirmMessage('')
      setConfirmIsValid(true)
      setIsValid(true)
      console.log('VALIDATION PASSED')
      const data = {
        orderId: orderId,
        newPassword: password,
        confirmPassword: confirmPassword,
      }
      await actions
        .resetWhatsAppPassword(data, ipData?.ip)
        .then((res) => {
          if (res.status) {
            toastr.success('', res.data?.msg)
            actions.setTab(1)
            setIsSending(false)
          } else {
            toastr.error('', res.data?.msg)
          }
        })
        .catch((e) => {
          toastr.error('', `${e?.msg}`)
        })
    }
  }

  const [timeLeft, setTimeLeft] = useState(null)

  const options = countryOptions.map((country) => ({
    value: country.value,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* <img
          src={`https://flagcdn.com/w20/${country.flag.toLowerCase()}.png`}
          alt={country.label}
          style={{ marginRight: 10 }}
        /> */}
        {country.label}
      </div>
    ),
    country: country.country,
    length: country.length,
  }))
  const [selectedCountry, setSelectedCountry] = useState(
    options.find((option) => option.value === '+91')
  )

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption)
  }

  const handleResendOtp = async () => {
    if (username?.length > 9) {
      await actions
        .resetPassword({
          country_code: selectedCountry?.value,
          mobile: username,
        })
        .then((res) => {
          console.log('res', res)
          if (res?.data?.status) {
            toastr.success('', res.data?.msg)
            setIsSendingOtp(false)
            setOrderId(res.data?.data?.orderId)
            setTimeLeft(Number(res.data.otp_expiry_time))
          } else {
            toastr.error('', res.data?.msg)
          }
          if (timeLeft > 0) {
            const timer = setInterval(() => {
              setTimeLeft((prevTime) => prevTime - 1)
            }, 1000) // Update every 1 second
            return () => clearInterval(timer)
          }

          // getBalance(res.data.result.memberCode)
          // onDidDismiss()
          setIsSending(false)
        })
        .catch((e) => toastr.error('', `${e?.msg}`))
    }
  }

  useEffect(() => {
    if (timeLeft !== null && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1)
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [timeLeft])

  // console.log(timeLeft, "timeLefttimeLeft")

  const [isOtpVerify, setIsOtpVerify] = useState(false)

  const handleVerifyOtp = async () => {
    await actions
      .getVerifyOtp({
        orderId: orderId,
        otp: otpUser,
      })
      .then((res) => {
        toastr.success('', res.data?.msg)
        setIsOtpVerify(true)
        // setIsSendingOtp(false)
        // setIsSending(false)
      })
      .catch((e) => {
        toastr.error('', e?.msg)
      })
  }

  console.log(isOtpVerify, 'isOtpVerifyisOtpVerify')

  return (
    <>
      {step === 3 && (
        <>
          {/*<div className="pop-up-content__buttons forgot-step two-buttons">*/}
          <div className="pop-up-content__buttons forgot-step">
            <button
              onClick={() => {
                if (isRulesAccepted) {
                  onDidDismiss(false)
                  actions.setTab(1)
                } else {
                  toastr.error('', `Please, accept the terms`)
                }
              }}
              className="pushable next-button"
              disabled={isSending}
            >
              <span className="shadow"></span>
              <span className="edge "></span>
              {width > 1024 && (
                <span className="front refreshBtn signUp">Confirm</span>
              )}
              {width < 1024 && (
                <div className="front refreshBtn">
                  <span>Confirm</span>
                </div>
              )}
            </button>
          </div>
        </>
      )}

      {step === 5 && (
        <>
          <div className="signUpNew_wrapper">
            {width < 1024 && (
              <div
                className="pop-up-content_title"
                onClick={() => onDidDismiss(false)}
              >
                <div
                  className="pop-up-content_title-logo"
                  style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '200px',
                    height: '52px',
                  }}
                ></div>
                <img src={closeLogin} />
              </div>
            )}

            <div className="loginPopUpContainer forgot-step">
              {width < 1024 && (
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: '20px',
                    color: '#ffffff',
                    paddingBottom: '20px',
                  }}
                >
                  Forgot Password
                </div>
              )}

              <div className="signUpNew_inputContainer">
                <div
                  className="placeholder "
                  style={{ left: '-10px', top: '6px' }}
                >
                  {/* +91 */}
                  <Select
                    options={options}
                    className="country_code"
                    style={{ width: '120px' }}
                    onChange={handleCountryChange}
                    placeholder="Select a country"
                    defaultValue={options.find(
                      (option) => option.value === '+91'
                    )} // Default to India
                    isSearchable={true}
                    filterOption={(option, inputValue) =>
                      option.data?.country
                        ?.toLowerCase()
                        .includes(inputValue.toLowerCase()) ||
                      option.data?.value
                        ?.toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    styles={{
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'center',
                        width: '150px!important',
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'center',
                        color: '#fff',
                      }),
                    }}
                  />
                </div>
                <input
                  className="signUpNew_inputContainer-input phone"
                  style={{
                    paddingLeft: '87px',
                  }}
                  onFocus={onfocusInput}
                  onBlur={onBlurInput}
                  formcontrolname="username"
                  placeholder="Phone Number"
                  name="username"
                  type="number"
                  autoComplete="username"
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  onIonChange={validateMobile}
                  onChange={validateMobile}
                  value={`${username?.replace(' ', '')}`}
                />
                <div className="signUpNew_inputContainer_row">
                  <div className="signUpNew_inputContainer_row-error">
                    {message}
                  </div>
                  <span
                    className={`signUpNew_inputContainer_row-counter ${
                      mobileNumCounter === 10 && 'counterDone'
                    }`}
                  >
                    {mobileNumCounter}/10
                  </span>
                </div>
                <div className="signUpNew_inputContainer_otp">
                  <div
                    className={`signUpNew_inputContainer_otp-button ${
                      username?.length < 10 || isOtpVerify
                        ? 'otpButtonDisabled'
                        : ''
                    }`}
                    // onClick={() => (!otpSent ? mobileValidationNew() : null)}
                    onClick={!isOtpVerify && handleResendOtp}
                  >
                    Get OTP
                  </div>
                </div>
              </div>

              <div div className="signUpNew_inputContainer">
                <input
                  className="signUpNew_inputContainer-input otp"
                  formcontrolname="otp"
                  placeholder="OTP"
                  name="otp"
                  type="number"
                  pattern="\d*"
                  autocomplete="one-time-code"
                  required
                  maxLength={6}
                  disabled={isSendingOtp}
                  onChange={(e) => validateOtp(e.target.value)}
                />
                <div className="signUpNew_inputContainer_otp">
                  <div
                    className={`signUpNew_inputContainer_otp-button ${
                      isOtpVerify ? 'otpButtonDisabled' : ''
                    }`}
                    onClick={!isOtpVerify && handleVerifyOtp}
                  >
                    Verify OTP
                  </div>
                </div>
                <div
                  className={`signUpMessageError ${
                    otpMessage && otp?.length ? 'otpMessage' : ''
                  }`}
                >
                  {otpMessage}
                </div>
                {(timeLeft !== null && !isOtpVerify) && (
                  <div className="signUpNew_inputContainer-resendOTP">
                    <div
                      style={
                        timeLeft === 0
                          ? { textDecoration: 'underline', cursor: 'pointer' }
                          : null
                      }
                      onClick={() =>
                        secondsNew === 0 ? setSecondsNew(59) : null
                      }
                    >
                      <span
                        className="signUpNew_inputContainer-resendOTP"
                        onClick={timeLeft === 0 ? resendOTP : null}
                      >
                        Resend OTP
                      </span>
                      {timeLeft === 0 ? null : <span> in {timeLeft}</span>}
                    </div>
                  </div>
                )}
              </div>
              {isOtpVerify && (
                <>
                  <div div className="signUpNew_inputContainer lock">
                    <input
                      required
                      ref={ref_input}
                      formcontrolname="122"
                      placeholder="Password"
                      name="122"
                      className={
                        hideFirstPass
                          ? 'signUpNew_inputContainer-input signup-password'
                          : 'signUpNew_inputContainer-input passwordDots'
                      }
                      autoComplete="off"
                      onKeyDown={onKeyDown}
                      onChange={(e) => validatePassword(e.target.value)}
                    />
                    <div
                      className={`${
                        hideFirstPass
                          ? 'signUpNew_icons eyeOff'
                          : 'signUpNew_icons eye'
                      } `}
                      onClick={() => setHideFirstPass(!hideFirstPass)}
                    ></div>

                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {passwordMessage}
                      </div>
                    </div>
                  </div>

                  <div div className="signUpNew_inputContainer lock">
                    <input
                      formcontrolname="122"
                      placeholder="Confirm Password"
                      name="122"
                      className={
                        hideSecondPass
                          ? 'signUpNew_inputContainer-input signup-password'
                          : 'signUpNew_inputContainer-input passwordDots'
                      }
                      autoComplete="off"
                      onKeyDown={onKeyDown}
                      onChange={(e) => validatePasswordConfirm(e.target.value)}
                    />
                    <div
                      className={`${
                        hideSecondPass
                          ? 'signUpNew_icons eyeOff'
                          : 'signUpNew_icons eye'
                      } `}
                      onClick={() => setHideSecondPass(!hideSecondPass)}
                    ></div>

                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {confirmMessage}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div
              className="pop-up-content__buttons  forgot-step two-buttons"
              style={{ marginBottom: '20px' }}
            >
              {width < 1024 && (
                <div
                  onClick={() => onDidDismiss(false)}
                  className="pushable back-button"
                >
                  <div className="front refreshBtn">
                    <span>Back</span>
                  </div>
                </div>
              )}
              {isOtpVerify && (
                <button
                  onClick={nextNew}
                  style={
                    isSending && width < 1024
                      ? { background: '#c0bdbd' }
                      : { marginBottom: '10px' }
                  }
                  className="pushable next-button signUpButton login"
                  // disabled={isDisabledButton()}
                >
                  Update password
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default connectLoginPopUp()(ForgotPasswordTab)
